import { Catalog } from './catalog';

export interface CatalogsResponse {
  catalogs: Catalog[];
}
